import { DateFormats } from 'constants/common';
import moment from 'moment';
import { formatCurrency } from 'utils';
import { CreditAppTableRow, CustomerTableRow, DocumentsTableRow } from '../types';
import { CustomerStatus } from '@trnsact/trnsact-shared-types';
import { CustomerStatusChip } from '../ui/components';
import { CreditAppsTableActionCell } from '../ui/pages/customerDetailsPage/tabs/creditAppsTab/CreditAppsTableActionCell';
import { FilenameCell } from '../ui/pages/customerDetailsPage/tabs/documentsTab/FilenameCell';
import { RelatedToCell } from '../ui/pages/customerDetailsPage/tabs/documentsTab/RelatedToCell';
import { DocumentsTableActionCell } from '../ui/pages/customerDetailsPage/tabs/documentsTab/DocumentsTableActionCell';

export const customersTableColumns = [
  {
    header: 'Account',
    renderKey: 'name',
    sortKey: 'name',
  },
  {
    header: 'Contact',
    renderKey: 'contactName',
    sortKey: 'contactName',
  },
  {
    header: 'Phone',
    renderKey: 'phone',
  },
  {
    header: 'Type',
    renderKey: 'type',
  },
  {
    header: 'Last Contact',
    renderKey: 'lastContactDate',
    sortKey: 'lastContactDate',
    renderCell: ({ lastContactDate }: CustomerTableRow) =>
      moment(lastContactDate).format(DateFormats.DateTimeShort12Hour),
  },
  {
    header: 'Status',
    renderKey: 'status',
    renderCell: ({ status }: CustomerTableRow) => <CustomerStatusChip status={status} />,
  },
  {
    header: 'Total Revenue',
    renderKey: 'totalRevenueAmount',
    sortKey: 'totalRevenueAmount',
    renderCell: ({ totalRevenueAmount }: CustomerTableRow) => formatCurrency(totalRevenueAmount),
  },
  {
    header: 'Active Deals',
    renderKey: 'activeDealsNumber',
    sortKey: 'activeDealsNumber',
  },
  {
    header: 'Opportunities',
    renderKey: 'opportunitiesNumber',
    sortKey: 'opportunitiesNumber',
  },
];

export const customerStatusChipSettings: Record<
  CustomerStatus,
  { color: string; bgColor: string; borderColor: string }
> = {
  [CustomerStatus.Active]: {
    color: '#43A047',
    bgColor: '#E8F5E9',
    borderColor: '#C8E6C9',
  },
};

export const creditAppsTableColumns = [
  {
    header: 'Date Received',
    renderKey: 'createdDateTime',
    renderCell: ({ createdDateTime }: CreditAppTableRow) =>
      moment(createdDateTime).format(DateFormats.DateTimeShort12Hour),
  },
  {
    header: 'Signed By',
    renderKey: 'signedBy',
  },
  {
    header: 'Sales Rep',
    renderKey: 'salesRep',
  },
  {
    header: 'Associated Location',
    renderKey: 'location',
  },
  {
    header: 'Associated Equipment',
    renderKey: 'equipment',
  },
  {
    header: 'Applying For',
    renderKey: 'applyingFor',
  },
  {
    header: 'Actions',
    renderKey: 'actions',
    renderCell: (row: CreditAppTableRow) => <CreditAppsTableActionCell row={row} />,
  },
];

export const documentsTableColumns = [
  {
    header: 'File Name',
    renderKey: 'docName',
    renderCell: (row: DocumentsTableRow) => <FilenameCell row={row} />,
  },
  {
    header: 'Uploaded By',
    renderKey: 'createdBy',
  },
  {
    header: 'Related To',
    renderKey: 'relatedTo',
    renderCell: (row: DocumentsTableRow) => <RelatedToCell row={row} />,
  },
  {
    header: 'Uploaded On',
    renderKey: 'createdDateTime',
    renderCell: ({ createdDateTime }: DocumentsTableRow) =>
      createdDateTime ? moment(createdDateTime).format(DateFormats.DateTimeShort12Hour) : '',
  },
  {
    header: 'Type',
    renderKey: 'docType',
  },
  {
    header: 'Descripton',
    renderKey: 'docDescription',
  },
  {
    header: 'Actions',
    renderKey: 'actions',
    renderCell: (row: DocumentsTableRow) => <DocumentsTableActionCell row={row} />,
  },
];
